module.exports = __webpack_public_path__ + "static/media/winnerTBN.5e2a06bf.svg";